import { render, staticRenderFns } from "./commentsList.vue?vue&type=template&id=4e822c7c"
import script from "./commentsList.vue?vue&type=script&lang=js"
export * from "./commentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports